import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreationProjetComponent } from './creation-projet.component';
import { Route, RouterModule } from '@angular/router';
import { CreationAnalysisProgressModule } from './creation-analysis-progress/creation-analysis-progress.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { CardUploadComponent } from './card-upload/card-upload.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { RedirectionPopUpComponent } from './redirection-pop-up/redirection-pop-up.component';
import { MatSelectModule } from '@angular/material/select';
import { SearchPipesModuleModule } from 'app/modules/settings/validation-rules/namedPipes/search-pipes-module/search-pipes-module.module';
import { PreventSpaceSelectDirectiveModule } from 'app/modules/working-order/directives/prevent-space-select-directive.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FileCardModule } from './file-card/file-card.module';
import { ProjectDisplayHistoryComponent } from '../history-display/project-display-history.component';
import { FuseCardModule } from '@fuse/components/card';

const projetRoutes: Route[] = [
  {
    path: 'creation',
    component: CreationProjetComponent,
  },
  // {
  //   path: '',
  //   pathMatch: 'full',
  //   component: CreationProjetComponent,
  // }
  // Temorary comment because this code blocks the display of the project details page (commit: 09df8d938eecdcdbd25f5f02e6bbbf19549d5a80).
];

@NgModule({
  declarations: [
    CreationProjetComponent,
    CardUploadComponent,
    RedirectionPopUpComponent,
    ProjectDisplayHistoryComponent
  ],
  imports: [
    CommonModule,
    CreationAnalysisProgressModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    RouterModule.forChild(projetRoutes),
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    SearchPipesModuleModule,
    PreventSpaceSelectDirectiveModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    FileCardModule,
    FuseCardModule
  ],
  exports: [CardUploadComponent]
})
export class CreationProjetModule { }
